<template>
  <Alert
    class="ma-3 mb-0"
    :prominent="!$vuetify.breakpoint.mobile"
    color="warning"
    outlined
  >
    <h4 class="mb-1 alert-text-color">
      <strong>{{ $t("scopesAlert.alertTitle") }}</strong>
    </h4>
    <p
      class="pa-0 ma-0 text-body-2 alert-text-color"
      v-html="scopeMessage1"
    ></p>
    <v-divider class="my-2 info" style="opacity: 0.22"></v-divider>
    <v-row class="ma-0 pa-0" no-gutters align="center">
      <v-col lg="9" sm="6" xs="12" md="8" class="pa-0 grow text-body-2">
        <span class="alert-text-color" v-html="$t('scopesAlert.alertMessage4')">
        </span>
      </v-col>

      <v-col
        lg="3"
        sm="6"
        xs="12"
        md="4"
        class="pa-0 mt-3 shrink d-flex justify-end"
      >
        <v-btn
          text
          small
          color="warning"
          :href="linkDocAboutScopes"
          target="_blank"
          class="mr-2 text-body-2 font-weight-medium"
        >
          {{ $t("action.knowMore") }}
        </v-btn>
        <v-btn
          v-if="isAdmin"
          text
          small
          outlined
          style="border: 1px #f39c12 solid"
          color="warning"
          :href="missingScopesLink"
          target="_blank"
          class="ml-auto text-body-2 font-weight-medium"
        >
          {{ $t("action.allowAccess") }}
        </v-btn>
      </v-col>
    </v-row>
  </Alert>
</template>

<script>
import Alert from "@/components/base/Alert.vue";
import {
  googleAppsPainelLink,
  googleScopesDocLink,
  microsoftAppsPainelLink,
  microsoftScopesDocLink,
} from "@/helpers/variables/links";
import { mapGetters } from "vuex";

export default {
  name: "ScopeAlert",
  components: {
    Alert,
  },
  computed: {
    ...mapGetters(["isAdmin", "isCompanyMicrosoft"]),

    scopeMessage1() {
      const providerName = this.isCompanyMicrosoft ? "Microsoft" : "Google";
      return this.$t("scopesAlert.alertMessage1", { provider: providerName });
    },
    linkDocAboutScopes() {
      return this.isCompanyMicrosoft
        ? microsoftScopesDocLink
        : googleScopesDocLink;
    },
    missingScopesLink() {
      return this.isCompanyMicrosoft
        ? microsoftAppsPainelLink
        : googleAppsPainelLink;
    },
  },
};
</script>
